import { render, staticRenderFns } from "./CardVoucher.vue?vue&type=template&id=4d98015c&scoped=true"
import script from "./CardVoucher.vue?vue&type=script&lang=js"
export * from "./CardVoucher.vue?vue&type=script&lang=js"
import style0 from "./CardVoucher.vue?vue&type=style&index=0&id=4d98015c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98015c",
  null
  
)

export default component.exports